export default {
    BLUE_COLOR_BUTTON: "#0d6efd",
    GREEN_COLOR_BUTTON: "#198754",
    AMBER_COLOR_BUTTON: "#ffa500",
    RED_COLOR_BUTTON: "#dc3545",
    GRAY_COLOR_BUTTON: "#808080",
};